import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, ListItem, ListItemText } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { setGlobalTag } from '../../../../redux/actions/global'
import { getTags } from '../../../../redux/actions/tags'
import { IRootState } from '../../../../redux/types'
import ListItemMenuButton from '../../styles/ListItemMenu'
import { TagContent, TagNav } from '../../styles/TagFilterStyles'

interface IBrand {
  id: number
  name: string
  activeLines: any
  tags: any
}

interface ITag {
  id: number
  name: string
}

function TagFilter({ layout }: any) {
  const { t } = useTranslation(['global'])
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(search)
  const dispatch = useDispatch()

  const { tags } = useSelector((state: IRootState) => state.tag)
  const { globalFamilyId, globalTag, globalBrandId } = useSelector((state: IRootState) => state.global)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  const [open, setOpen] = useState(true)

  useEffect(() => {
    dispatch(getTags())
  }, [globalFamilyId])

  useEffect(() => {
    if (tags.length > 0) {
      if (search && searchParams.get('globalTag') !== null) {
        handleGlobalTag(Number(searchParams.get('globalTag')))
      }
    }
  }, [tags])

  const handleClick = () => {
    setOpen(!open)
  }

  const handleGlobalTag = (tag: number) => {
    localStorage.setItem('globalTag', tag.toString())
    dispatch(setGlobalTag(tag))
    searchParams.set('globalTag', tag.toString())
    navigate(`${pathname}?${searchParams}`, { replace: true })
  }

  const handleGlobalTagNull = () => {
    localStorage.setItem('globalTag', 'null')
    dispatch(setGlobalTag(null))
    searchParams.delete('globalTag')
    navigate(`${pathname}?${searchParams}`, { replace: true })
  }

  const ListItemTag = ({ id, name }: ITag) => {
    return (
      <ListItem key={id} onClick={() => handleGlobalTag(id)} className={id === globalTag ? 'active' : ''}>
        <ListItemText primary={name} />
      </ListItem>
    )
  }

  return (
    <>
      {tags.length > 0 && (
        <TagNav id="nav-tag-filter" className={layout}>
          <ListItemMenuButton onClick={() => handleClick()} className={layout}>
            <ListItemText primary={t('categories')} />
            {open ? <ExpandLess color="primary" fontSize="small" /> : <ExpandMore color="primary" fontSize="small" />}
          </ListItemMenuButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TagContent disablePadding className={layout}>
              <ListItem key={'tag-0'} onClick={() => handleGlobalTagNull()} className={null === globalTag ? 'active' : ''}>
                <ListItemText primary={t('all')} />
              </ListItem>
              {globalBrandId !== null
                ? userBrands
                    .find((brand: IBrand) => brand.id === globalBrandId)
                    ?.tags.map((tag: ITag) => <ListItemTag key={tag.id} id={tag.id} name={tag.name} />)
                : tags.map((tag: ITag) => <ListItemTag key={tag.id} id={tag.id} name={tag.name} />)}
            </TagContent>
          </Collapse>
        </TagNav>
      )}
    </>
  )
}

export default TagFilter
